import {Redirect} from "react-router";
import React from "react";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";

class TicketFromMail extends React.Component {

    render() {
        const {ticketID} = this.props.match.params

        return (
            <Redirect to={"/tickets/" + ticketID} />
        )

    }
}
export default withRouter(
    connect(
    )(TicketFromMail)
);
